import React, { useState, useEffect } from 'react';
import '../styles/team.css';
import { DEFAULT_PERSON_IMAGE } from '../constants';
import { useTranslation } from 'react-i18next';
import DataContext from '../contexts/DataContext';
import { BASE_URL } from '../constants';

const Team = () => {
  const { t, i18n } = useTranslation('team');
  const { groups, people, isLoading } = React.useContext(DataContext);

  const targetGroup = groups.find(group => group.id === 5);

  const renderIntegrantes = (integrantes) => {
    const faculty = [];
    const ugrad = [];
    const master = [];

    integrantes.forEach(integrante => {
      const person = people.find(p => p.username === integrante);
      if (person) {
        if (person.role === 'faculty' || person.role === 'Lab Coordinator') {
          faculty.push(person);
        } else if (person.role === 'ugrad') {
          ugrad.push(person);
        } else if (person.role === 'master') {
          master.push(person);
        }
      }
    });

    const renderGroup = (group) => {
      return (
        <div className="integrantes-roww row d-flex justify-content-center">
          {group.map((person, index) => {
            const isUrl = person.image && (person.image.startsWith('http://') || person.image.startsWith('https://'));
            const imageSrc = person.image
              ? (isUrl ? person.image : `${BASE_URL}images/people/${person.image}`)
              : DEFAULT_PERSON_IMAGE;

            return (
              <div key={index} className="integrante-itemm col-md-2 col-sm-6 col-12 text-center">
                <img
                  src={imageSrc}
                  className="rounded-circle member"
                  alt={`Integrante ${person.display_name}`}
                  style={{ width: '100px', height: '100px' }}
                />
                <div className="integrante-name">{person.display_name}</div>
                <div className="integrante-bio">{person.bio}</div>
              </div>
            );
          })}
        </div>
      );
    };

    return (
      <div>
        <h3>{t('professors-coordinators')}</h3>
        {renderGroup(faculty)}
        <h3>{t('master-students')}</h3>
        {renderGroup(master)}
        <h3>{t('undergrad-students')}</h3>
        {renderGroup(ugrad)}
      </div>
    );
  };

  if (isLoading) {
    return <div className="loading">{t('loading')}</div>;
  }

  if (!targetGroup) {
    return <div>{t('not-found')}</div>;
  }

  return (
    <div className="team-container d-flex justify-content-center align-items-center">
      <div className="col-md-8 col-12 text-center">
        <h1>{targetGroup.nombre}</h1>
        {targetGroup.fotoGrupo && (
          <img
            src={`${BASE_URL}images/groups/${targetGroup.fotoGrupo}`}
            alt={`Imagen ${targetGroup.fotoGrupo}`}
            className="team-photo"
          />
        )}
        <p>{targetGroup.descripcion}</p>
        {renderIntegrantes(targetGroup.members)}
      </div>
    </div>
  );
};

export default Team;
